module.exports = __webpack_public_path__ + "img/phone.f8b1bdea.svg";